<template>
  <b-modal id="sales-filters" size="md" :title="$t('client.text_1649')">
    <b-row>
      <b-col cols="12">
        <b-form novalidate>
          <b-row>
            <b-col cols="6">
              <b-form-group :label="$t('client.text_47')" label-for="date-in">
                <b-form-input
                  id="date-in"
                  v-model="data.date_in"
                  type="date"
                  placeholder="31/12/2019"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group :label="$t('client.text_4')" label-for="date-out">
                <b-form-input
                  id="date-out"
                  v-model="data.date_out"
                  type="date"
                  placeholder="31/12/2020"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-form-group :label="$t('client.text_70')" label-for="date-in">
                <b-form-select
                  v-model="data.status"
                  :options="status_list"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <h5>{{ $t('client.text_49') }}</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4">
              <b-form-group :label="$t('client.text_50')" label-for="date-in">
                <b-form-select
                  v-model="data.client_type"
                  :options="client_search"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="8">
              <b-form-group :label="$t('client.text_49')" label-for="client_data">
                <b-form-input
                  id="client_data"
                  v-model="data.client_data"
                  type="text"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>

    <template v-slot:modal-footer="{ cancel }">
      <b-button variant="danger" @click="cancel()"> {{ $t('client.text_51') }} </b-button>
      <button class="btn-green" @click="onSubmit">{{ $t('client.text_52') }}</button>
    </template>
  </b-modal>
</template>
<script>

export default {
  props: {
    value: {
      type: Number,
    },
  },
  data() {
    return {
      data: {
        date_in: null,
        date_out: null,
        status: null,
        client_type: null,
        client_data: null,
      },
      status_list: [
        { value: null, text: this.$t('client.text_53') },
        { value: "paid", text: this.$t('client.text_54') },
        { value: "processing", text: this.$t('client.text_55') },
        { value: "reject", text: this.$t('client.text_56') },
      ],
      client_search: [
        { value: null, text: this.$t('client.text_57') },
        { value: "email", text: this.$t('client.text_1648') },
        { value: "name", text: this.$t('client.text_58') },
        { value: "cellphone", text: this.$t('client.text_59') },
      ],
    };
  },
  methods: {
    onSubmit() {
      if (
        (this.data.date_in != null && this.data.date_out != null) ||
        this.data.status != null ||
        (this.data.client_type != null && this.data.client_data != null)
      ) {
        this.$emit("filter", this.data);
        this.$bvModal.hide("sales-filters");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-green {
  display: inline-block;
  border-radius: 5px;
  padding: 7px 20px;
  border: 1px var(--old-500) solid;
  width: auto;
  color: var(--gray-white);
  background: var(--old-500);
  cursor: pointer;

  &:hover {
    background: var(--gray-white);
    color: var(--old-500);
    border: 1px var(--old-500) solid;
  }
}
</style>